<div
  [ngStyle]="{
    'font-weight': isBold ? '700' : '500',
    'background-color': backgroundColor || '#00000011'
  }"
>
  <ng-content></ng-content>
  <span *ngIf="value !== null && value !== undefined">{{ value }}</span>
  <p *ngIf="unitMeasurement">{{ unitMeasurement }}</p>
  <span *ngIf="description">{{ description }}</span>
</div>
